import { render, staticRenderFns } from "./VoiceAgentDeleted.vue?vue&type=template&id=1a3f2ae2"
import script from "./VoiceAgentDeleted.vue?vue&type=script&lang=js"
export * from "./VoiceAgentDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports